export function deduplicateSystems(rows: Array<{ system: string | null }>): string[] {
  return Array.from(
    new Set(rows.map((r) => r.system).filter((s): s is string => Boolean(s)))
  ).sort()
}
